<script setup>
import FormInput from "@/Components/FormInput.vue";

import { inject } from "vue";

const parentProps = inject("myProps");
</script>

<template>
    <div class="mt-4 w-full sm:w-3/4">
        <div class="mb-8 border-b text-lg">
            <template
                v-if="
                    parentProps.selectedEventClass &&
                    parentProps.selectedEventClass.vehicle_type === 'motorcycle'
                "
            >
                Motorcycle info
            </template>
            <strong v-else>Vehicle info</strong>
        </div>

        <span
            v-if="!parentProps.selectedEventClass"
            class="cursor-pointer text-red-600"
            @click="parentProps.tab_selected = 'general'"
            >Please select the "Event Class" under the "General" tab.</span
        >
        <div
            v-else
            class="mt-4"
        >
            <div
                v-if="parentProps.myvehicles.length"
                class="mt-1 block w-full"
            >
                <FormInput
                    v-model="parentProps.myvehicles_selected"
                    label="Autofill from My Vehicles (optional)"
                    type="select"
                    class="bg-gray-200"
                    :options="parentProps.myvehicles"
                    placeholder="Select Vehicle"
                    empty-option="Select Vehicle"
                ></FormInput>
            </div>

            <div :class="parentProps.myvehicles.length ? 'mt-4' : ''">
                <FormInput
                    v-model="parentProps.form.vehicle.make"
                    type="text"
                    label="Make *"
                    :error="
                        Object.hasOwn(parentProps.form.errors, 'vehicle.make')
                            ? parentProps.form.errors['vehicle.make']
                            : null
                    "
                />
            </div>

            <div class="mt-4">
                <FormInput
                    v-model="parentProps.form.vehicle.model"
                    type="text"
                    label="Model *"
                    :error="
                        Object.hasOwn(parentProps.form.errors, 'vehicle.model')
                            ? parentProps.form.errors['vehicle.model']
                            : null
                    "
                />
            </div>

            <div class="mt-4">
                <FormInput
                    v-model="parentProps.form.vehicle.cc"
                    type="number"
                    step="1"
                    label="Engine size (displacement cc) *"
                    :error="
                        Object.hasOwn(parentProps.form.errors, 'vehicle.cc')
                            ? parentProps.form.errors['vehicle.cc']
                            : null
                    "
                />
            </div>

            <div class="mt-4">
                <FormInput
                    v-model="parentProps.form.vehicle.licence_plate"
                    type="text"
                    label="Vehicle registration number (licence plate No.) *"
                    :error="
                        Object.hasOwn(parentProps.form.errors, 'vehicle.licence_plate')
                            ? parentProps.form.errors['vehicle.licence_plate']
                            : null
                    "
                />
            </div>

            <template v-if="$page.props.event.type === 'full'">
                <div class="mt-4">
                    <FormInput
                        v-model="parentProps.form.vehicle.country"
                        type="select"
                        label="Country of registration"
                        :error="
                            Object.hasOwn(parentProps.form.errors, 'vehicle.country')
                                ? parentProps.form.errors['vehicle.country']
                                : null
                        "
                        :options="parentProps.countries"
                    />
                </div>

                <div class="mt-4">
                    <FormInput
                        v-model="parentProps.form.vehicle.year"
                        type="text"
                        label="Year of manufacture"
                        :error="
                            Object.hasOwn(parentProps.form.errors, 'vehicle.year')
                                ? parentProps.form.errors['vehicle.year']
                                : null
                        "
                    />
                </div>

                <div class="mt-4">
                    <FormInput
                        v-model="parentProps.form.vehicle.insurance"
                        type="text"
                        label="Vehicle insurance policy company and number"
                        :error="
                            Object.hasOwn(parentProps.form.errors, 'vehicle.insurance')
                                ? parentProps.form.errors['vehicle.insurance']
                                : null
                        "
                    />
                </div>
            </template>
        </div>
    </div>
</template>
